import { createWebHistory, createRouter } from 'vue-router'

import LoginPage from '@/components/LoginPage.vue'
import VkCallback from '@/components/VkCallback.vue'
import ProfileSettings from '@/components/ProfileSettings.vue'
import MainPage from '@/components/MainPage.vue'
import GroupsManagement from '@/components/GroupsManagement.vue'
import CreatTestsForm from '@/components/CreatTestsForm.vue'
import TestingInProgress from '@/components/TestingInProgress.vue'
import AcceptInvite from '@/components/AcceptInvite.vue'

const routes = [
    {
        path: '/login',
        component: LoginPage  
    },
    {
        path: '/vk/callback',
        component: VkCallback
    },
    {
        path: '/',
        component: MainPage
    },
    {
        path: '/groups',
        component: GroupsManagement
    },
    {
        path: '/join',
        component: AcceptInvite
    },
    {
        path: '/profile',
        component: ProfileSettings
    },
    {   
        path: '/create_tests',
        component: CreatTestsForm
    },
    {   
        path: '/testing',
        component: TestingInProgress
    }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router